import axios from "axios";

import ApiException from "./ApiException";
import config from "@/app.config.json";
import { ValidacaoResult } from "@/services/Interfaces/IValidacaoResult";

const urlBase = `${config.urlApi}/ContratosComposicoes`;

const urls = {
  obter: `${urlBase}`,
  adicionar: `${urlBase}`,
  excluir: `${urlBase}`,
}


function getToken(): string {

  const x = localStorage.getItem('user');

  if (x != null) {
    const user = JSON.parse(x);

    if (user && user.accessToken) {
      return `Bearer  ${user.accessToken}`;
    } else {
      return "";
    }
  }
  else
    return "";
}

export const obter = (params?: Filtros | null | any): Promise<ContratoComposicao[]> => {
  return new Promise((resolve, reject) => {

    axios.defaults.headers.common.Authorization = getToken();

    axios
      .get(urls.obter, { params })
      .then((r) => {
        return resolve(r.data);
      })
      .catch(error => reject(new ApiException(error || "Falha ao obter ")));
  });
};

export async function adicionar(model: ContratoComposicao): Promise<ContratoComposicao> {
  try {
    axios.defaults.headers.common.Authorization = getToken();
    return (await axios.post(urls.adicionar, model)).data
  } catch (error: any) {
    throw new ApiException(error || "Falha ao salvar ");
  }
}

export async function excluir(id: number): Promise<void> {
  axios.defaults.headers.common.Authorization = getToken();
  await axios.delete(`${urls.excluir}/${id}`)
}


export interface Filtros {
  contratoId: number | null;
}

export interface ContratoComposicao {
  id: number;
  contratoId: number;
  clienteId: number | null;
  planoId: number | null;
  cliente: { clienteId: number; nome: string } | null;
  plano: { planoId: number; nome: string } | null;

  dataCadastro: string | null;
  usuCadastroId: number | null;
  dataAlteracao: string | null;
  usuAlteracaoId: number | null;
  dataExclusao: string | null;
  usuExclusaoId: number | null;
  modelState: ValidacaoResult;
}
